<template>
  <div class="pb-1">
    <!-- loading -->
    <div v-if="this.loadpage == true" class="text-center">
      <b-spinner
        style="width: 5rem; height: 5rem;"
        variant="primary"
        label="Large Spinner"
      />
    </div>

    <div v-if="this.loadpage == false">
      <b-card no-body>
        <b-card-header class="d-flex justify-content-between align-items-center">
          <h4 class="mb-0">Balance ลูกค้า</h4>
          <b-button variant="primary" size="sm" @click="openPaymentModal()">แจ้งชำระเงิน</b-button>
        </b-card-header>
        <hr class="my-0 mx-2">
        <b-card-body>
          <b-tabs v-model="tabIndex">
            <!-- Tab เงินบาท -->
            <b-tab title="Balance เงินบาท" active>
              <div class="d-md-flex align-items-center mb-1 pl-md-0 col-md-9">
                <span class="px-0 col-1"> วันที่: </span>
                <flat-pickr v-model="bahtStart" class="form-control" :config="datePickerConfig"/>
                <span class="px-1"> - </span>
                <span class="px-0 col-1"> ถึงวันที่: </span>
                <flat-pickr v-model="bahtEnd" class="form-control mr-1" :config="datePickerConfig"/>
                <b-button variant="primary" @click="getBalancePage()">ค้นหา</b-button>
              </div>

              <b-table
                responsive
                :items="bahtBalance"
                :fields="balanceFields"
                table-class="table-md-responsive text-nowrap"
              >
                <template #cell(balanceId)="data">
                  <feather-icon
                    :id="`edit-baht-${data.value}`"
                    icon="EditIcon"
                    size="20"
                    class="cursor-pointer text-warning"
                    @click="openEditModal('baht', data.item)"
                  />
                  <b-tooltip title="แก้ไข" :target="`edit-baht-${data.value}`" :delay="{show: '1500'}"/>
                </template>
                <template #cell(customerId)="data">
                  <feather-icon
                    :id="`delete-baht-${data.item.balanceId}`"
                    icon="Trash2Icon"
                    size="20"
                    class="cursor-pointer text-danger"
                    @click="confirmDelete('baht', data.item)"
                  />
                  <b-tooltip title="ลบ" :target="`delete-baht-${data.item.balanceId}`" :delay="{show: '1500'}"/>
                </template>
                <template #cell(balanceDate)="data">
                  {{formatDatetime(data.value)}}
                </template>
                <template #cell(description)="data">
                  <span v-if="data.item.income != null">{{data.value}}</span>
                  <span v-else class="pl-1">{{data.value}}</span>
                </template>
                <template #cell(income)="data">
                  <div v-if="data.item.income != null" style="color:green" class="text-right">
                    + {{format_price(data.value)}}
                  </div>
                </template>
                <template #cell(expense)="data">
                  <div v-if="data.item.expense != null" style="color:red" class="text-right">
                    - {{format_price(data.value)}}
                  </div>
                </template>
                <template #cell(total)="data">
                  <div class="text-right">
                    {{format_price(data.value)}}
                  </div>
                </template>
              </b-table>
            </b-tab>

            <!-- Tab เงินหยวน -->
            <b-tab title="Balance เงินหยวน">
              <div class="d-md-flex align-items-center mb-1 pl-md-0 col-md-9">
                <span class="px-0 col-1"> วันที่: </span>
                <flat-pickr v-model="yuanStart" class="form-control" :config="datePickerConfig"/>
                <span class="px-1"> - </span>
                <span class="px-0 col-1"> ถึงวันที่: </span>
                <flat-pickr v-model="yuanEnd" class="form-control mr-1" :config="datePickerConfig"/>
                <b-button variant="primary" @click="getBalancePage()">ค้นหา</b-button>
              </div>

              <b-table
                responsive
                :items="yuanBalance"
                :fields="balanceFields"
                table-class="table-md-responsive text-nowrap"
              >
                <template #cell(balanceId)="data">
                  <feather-icon
                    :id="`edit-yuan-${data.value}`"
                    icon="EditIcon"
                    size="20"
                    class="cursor-pointer text-warning"
                    @click="openEditModal('yuan', data.item)"
                  />
                  <b-tooltip title="แก้ไข" :target="`edit-yuan-${data.value}`" :delay="{show: '1500'}"/>
                </template>
                <template #cell(customerId)="data">
                  <feather-icon
                    :id="`delete-yuan-${data.item.balanceId}`"
                    icon="Trash2Icon"
                    size="20"
                    class="cursor-pointer text-danger"
                    @click="confirmDelete('yuan', data.item)"
                  />
                  <b-tooltip title="ลบ" :target="`delete-yuan-${data.item.balanceId}`" :delay="{show: '1500'}"/>
                </template>
                <template #cell(balanceDate)="data">
                  {{formatDatetime(data.value)}}
                </template>
                <template #cell(description)="data">
                  <span v-if="data.item.income != null">{{data.value}}</span>
                  <span v-else class="pl-1">{{data.value}}</span>
                </template>
                <template #cell(income)="data">
                  <div v-if="data.item.income != null" style="color:green" class="text-right">
                    + {{format_price(data.value)}}
                  </div>
                </template>
                <template #cell(expense)="data">
                  <div v-if="data.item.expense != null" style="color:red" class="text-right">
                    - {{format_price(data.value)}}
                  </div>
                </template>
                <template #cell(total)="data">
                  <div class="text-right">
                    {{format_price(data.value)}}
                  </div>
                </template>
              </b-table>
              <p>
                <b-button class="float-right" variant="primary" size="sm" @click="openExchangeModal()">แลกเงินหยวนเป็นบาท</b-button>
              </p>
            </b-tab>
          </b-tabs>
        </b-card-body>
      </b-card>
    </div>

    <!-- Edit Balance Modal -->
    <b-modal
      id="balanceModal"
      ref="balanceModal"
      @hidden="resetForm"
      title-class="h4"
      :title="modalTitle"
      hide-footer
      content-class="shadow"
      no-close-on-backdrop
    >
      <b-form>
        <b-row class="px-1">
          <b-col cols="12">
            <b-form-group label="ประเภท *" label-cols-md="3">
              <b-form-select v-model="form.type" :options="typeOptions" />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="จำนวนเงิน *" label-cols-md="3">
              <b-form-input v-model="form.amount" type="number" step="0.01" placeholder="0.00" />
              <span v-if="val.amount === false" style="color:red">กรุณากรอกจำนวนเงิน</span>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="รายละเอียด *" label-cols-md="3">
              <b-form-input v-model="form.description" placeholder="รายละเอียด" />
              <span v-if="val.description === false" style="color:red">กรุณากรอกรายละเอียด</span>
            </b-form-group>
          </b-col>
        </b-row>
        <hr class="dense"/>
        <div class="d-flex justify-content-end">
          <b-button variant="outline-secondary" size="sm" class="mr-1" @click="$refs['balanceModal'].hide()">
            ยกเลิก
          </b-button>
          <b-button
            variant="primary"
            size="sm"
            :disabled="loadButton === false"
            @click="submitBalance()"
          >
            <b-spinner v-if="loadButton === false" small />
            บันทึกการแก้ไข
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- Payment Modal (แจ้งชำระเงิน) -->
    <b-modal
      id="paymentModal"
      ref="paymentModal"
      @hidden="resetPaymentForm"
      title-class="h4"
      title="แจ้งชำระเงิน"
      hide-footer
      content-class="shadow"
      no-close-on-backdrop
      size="lg"
    >
      <b-form>
        <b-row>
          <!-- ชำระโดย -->
          <b-col cols="12">
            <b-form-group class="font-weight-bolder" label="ชำระโดย :" label-cols-md="3">
              <b-form-radio v-model="payment.choosePayment" plain name="payment" value="A">
                <h6 class="font-weight-normal">โอนเงินผ่านธนาคาร</h6>
              </b-form-radio>
              <b-form-radio v-model="payment.choosePayment" plain name="payment" value="B">
                <h6 class="font-weight-normal">หักยอดเงินบาทจาก Balance</h6>
              </b-form-radio>
            </b-form-group>
          </b-col>
          <!-- ธนาคาร -->
          <b-col cols="12" v-if="payment.choosePayment == 'A'">
            <b-form-group class="font-weight-bolder" label="ธนาคาร :" label-cols-md="3">
              <b-form-radio
                v-for="bank in bankInfo"
                :key="bank.bankId"
                v-model="payment.chooseBank"
                :value="bank.bankId"
                plain
                name="bank"
              >
                <h6 class="font-weight-normal">{{bank.fullBankName}}</h6>
              </b-form-radio>
              <span v-if="valPayment.bank === false" style="color:red">กรุณาเลือกธนาคาร</span>
            </b-form-group>
          </b-col>
          <!-- ยอดที่โอน -->
          <b-col cols="12" v-if="payment.choosePayment == 'A'">
            <b-form-group class="font-weight-bolder" label="ยอดที่โอน :" label-cols-md="3">
              <div class="d-flex align-items-center">
                <cleave
                  v-model="payment.amount"
                  class="form-control col-md-5"
                  :raw="false"
                  :options="cleaveOptions"
                />
                <h6 class="font-weight-normal ml-1">บาท</h6>
              </div>
              <span v-if="valPayment.amount === false" style="color:red">กรุณากรอกยอดที่โอน</span>
            </b-form-group>
          </b-col>
          <!-- วันที่ -->
          <b-col cols="12" v-if="payment.choosePayment == 'A'">
            <b-form-group class="font-weight-bolder" label="วันที่ :" label-cols-md="3">
              <flat-pickr v-model="payment.date" class="form-control col-md-5" :config="datePickerConfig"/>
            </b-form-group>
          </b-col>
          <!-- เวลา -->
          <b-col cols="12" v-if="payment.choosePayment == 'A'">
            <b-form-group class="font-weight-bolder" label="เวลาประมาณ :" label-cols-md="3">
              <flat-pickr
                v-model="payment.time"
                class="form-control col-md-5"
                :config="{ enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}"
              />
            </b-form-group>
          </b-col>
          <!-- เพื่อชำระ -->
          <b-col cols="12">
            <b-form-group class="font-weight-bolder" label="เพื่อชำระ :" label-cols-md="3">
              <b-form-select
                v-if="payment.choosePayment == 'A'"
                v-model="payment.selectedPayment"
                :options="transfers"
                value-field="paymentID"
                text-field="description"
                class="form-control col-md-5"
              >
                <b-form-select-option :value="null">--กรุณาเลือกรายการ--</b-form-select-option>
              </b-form-select>
              <b-form-select
                v-if="payment.choosePayment == 'B'"
                v-model="payment.selectedPayment"
                :options="balanceDeducts"
                value-field="paymentID"
                text-field="description"
                class="form-control col-md-5"
              >
                <b-form-select-option :value="null">--กรุณาเลือกรายการ--</b-form-select-option>
              </b-form-select>
              <span v-if="valPayment.selectedPayment === false" style="color:red">กรุณาเลือกรายการ</span>
            </b-form-group>
          </b-col>
          <!-- แนบรูป -->
          <b-col cols="12" v-if="payment.choosePayment == 'A'">
            <b-form-group class="font-weight-bolder" label="แนบรูป :" label-cols-md="3">
              <div class="d-flex align-items-center">
                <b-form-file
                  class="col-md-5"
                  v-model="payment.pic"
                  placeholder="Choose a file"
                  drop-placeholder="Drop file here..."
                />
                <h6 class="font-weight-normal ml-1">*แนบสลิปโอนเงิน</h6>
              </div>
            </b-form-group>
          </b-col>
          <!-- หมายเหตุ -->
          <b-col cols="12">
            <b-form-group class="font-weight-bolder" label="หมายเหตุ :" label-cols-md="3">
              <b-form-textarea
                v-model="payment.remark"
                placeholder=""
                rows="4"
                class="col-md-5"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <hr/>
        <div class="d-flex justify-content-end">
          <b-button variant="outline-secondary" size="sm" class="mr-1" @click="$refs['paymentModal'].hide()">
            ยกเลิก
          </b-button>
          <b-button
            variant="primary"
            size="sm"
            :disabled="loadBtnPayment === false"
            @click="submitPayment()"
          >
            <b-spinner v-if="loadBtnPayment === false" small />
            แจ้งชำระเงิน
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- Exchange Yuan to Baht Modal -->
    <b-modal
      id="exchangeModal"
      ref="exchangeModal"
      @hidden="resetExchangeForm"
      title-class="h4"
      title="แลกเงินหยวนเป็นบาท"
      hide-footer
    >
      <b-form>
        <b-row class="px-1">
          <b-col cols="12">
            <b-form-group label="เรทแลกคืน :" label-cols-md="4">
              <div>1 หยวน = {{format_price(this.rateYuan)}} บาท</div>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="จำนวนเงินหยวน :" label-cols-md="4">
              <cleave
                v-model="exchangeAmountYuan"
                class="form-control"
                :raw="false"
                :options="cleaveOptions"
                :placeholder="'ยอดหยวนที่มี ' + this.totalYuan + ' หยวน'"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label-cols-md="4">
              <div v-if="this.exchangeCheckNull == false">แลกได้ {{format_price(this.exchangeTotalBaht)}} บาท</div>
            </b-form-group>
          </b-col>
        </b-row>
        <hr class="dense"/>
        <div class="float-right">
          <b-button variant="outline-danger" size="sm" @click="$refs['exchangeModal'].hide()">ยกเลิก</b-button>
          <b-button
            class="ml-2"
            variant="primary"
            size="sm"
            :disabled="this.exchangeAmountYuan == '' || this.loadBtnExchange == false"
            @click="exchangeYuanToBaht()"
          >
            <b-spinner v-if="this.loadBtnExchange == false" small />
            ดำเนินการ
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import {
  BFormFile, BFormGroup, BFormSelect, BFormSelectOption, BFormInput,
  BButton, BCardBody, BCard, BTabs, BTab, BSpinner, BRow, BCol,
  BFormTextarea, BCardHeader, BFormRadio, BModal, BForm,
  BTable, BTooltip,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import Cleave from 'vue-cleave-component'
import { format_price, formatDatetime, formatDate_dmy, formatDate_eng } from '@/views/global_function.js'
import { header_token } from '@/views/token.js'
import { taobaoService_dotnet } from '@/views/global.js'
import axios from 'axios'

export default {
  name: 'AdminBranchBalance',

  components: {
    BSpinner, BCard, BCardBody, BCardHeader, BFormSelect, BFormSelectOption, BFormInput, BTable, BTooltip,
    BButton, BTabs, BTab, BModal, BForm, BFormGroup, BRow, BCol, BFormRadio, BFormFile, BFormTextarea,
    flatPickr,
    Cleave,
  },

  data() {
    return {
      customerId: null,
      tabIndex: 0,

      bahtBalance: [],
      yuanBalance: [],

      balanceFields: [
        { key: 'balanceId', label: 'แก้ไข', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'customerId', label: 'ลบ', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'balanceDate', label: 'วันที่', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'description', label: 'รายละเอียด'},
        { key: 'income', label: 'เข้า', thClass: 'text-right', tdClass: 'text-right'},
        { key: 'expense', label: 'ออก', thClass: 'text-right', tdClass: 'text-right'},
        { key: 'total', label: 'คงเหลือ', thClass: 'text-right', tdClass: 'text-right'},
      ],

      bahtStart: null,
      bahtEnd: null,
      yuanStart: null,
      yuanEnd: null,
      datePickerConfig: {
        altInput: true,
        altFormat: "d-m-Y",
      },

      cleaveOptions: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralPositiveOnly: true,
      },

      // edit balance modal
      isEdit: false,
      balanceType: 'baht',
      loadButton: true,
      form: {
        balanceId: null,
        type: 'income',
        amount: '',
        description: '',
      },
      val: {
        amount: null,
        description: null,
      },
      typeOptions: [
        { value: 'income', text: 'เงินเข้า' },
        { value: 'expense', text: 'เงินออก' },
      ],

      // payment modal
      loadBtnPayment: true,
      bankInfo: [],
      transfers: [],
      balanceDeducts: [],
      payment: {
        choosePayment: 'A',
        chooseBank: '',
        amount: null,
        date: new Date(),
        time: new Date().toLocaleString(undefined, {hour: '2-digit', hour12: false, minute:'2-digit'}),
        selectedPayment: null,
        pic: null,
        remark: '',
      },
      valPayment: {
        bank: null,
        amount: null,
        selectedPayment: null,
      },

      // exchange yuan modal
      rateYuan: null,
      totalYuan: null,
      exchangeTotalBaht: null,
      exchangeAmountYuan: '',
      exchangeCheckNull: true,
      loadBtnExchange: true,

      loadpage: true,
    };
  },

  computed: {
    modalTitle() {
      const currency = this.balanceType === 'baht' ? 'เงินบาท' : 'เงินหยวน'
      return this.isEdit ? `แก้ไขรายการ${currency}` : `เพิ่มรายการ${currency}`
    },
  },

  watch: {
    exchangeAmountYuan() {
      if (this.exchangeAmountYuan != '') {
        var yuan = Number(this.exchangeAmountYuan.replace(/,/g, ""))
        this.exchangeTotalBaht = yuan * this.rateYuan
        this.exchangeCheckNull = false
        if (yuan > this.totalYuan) {
          this.exchangeAmountYuan = this.totalYuan.toString()
        }
      } else {
        this.exchangeCheckNull = true
      }
    },
  },

  async created() {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const encodedId = urlParams.get('id')
    this.customerId = atob(encodedId)
    const type = urlParams.get('type')
    if (type === '2') {
      this.tabIndex = 1
    }
    await this.getBalancePage()
    this.getListPayment()
    this.getRateYuan()
    this.loadpage = false
  },

  methods: {
    format_price, formatDatetime, formatDate_dmy, formatDate_eng,

    // ============ Balance Page ============
    async getBalancePage() {
      let response = await axios.post(
        taobaoService_dotnet + 'app/Branch/load-balance-page',
        {
          "customerID": this.customerId,
          "bathStartDate": this.bahtStart,
          "bathEndDate": this.bahtEnd,
          "yuanStartDate": this.yuanStart,
          "yuanEndDate": this.yuanEnd,
          "isMobile": false
        },
        { headers: header_token }
      )
      this.bahtStart = response.data.bathStartDate
      this.bahtEnd = response.data.bathEndDate
      this.yuanStart = response.data.yuanStartDate
      this.yuanEnd = response.data.yuanEndDate
      this.bahtBalance = response.data.customerBalances
      this.yuanBalance = response.data.customerYuanBalances
    },

    // ============ Edit Balance Modal ============
    openEditModal(type, item) {
      this.isEdit = true
      this.balanceType = type
      this.resetForm()
      this.form.balanceId   = item.balanceId
      this.form.type        = item.income != null ? 'income' : 'expense'
      this.form.amount      = item.income != null ? item.income : item.expense
      this.form.description = item.description || ''
      this.$refs['balanceModal'].show()
    },

    resetForm() {
      this.loadButton       = true
      this.form.balanceId   = null
      this.form.type        = 'income'
      this.form.amount      = ''
      this.form.description = ''
      this.val.amount       = null
      this.val.description  = null
    },

    validateForm() {
      let valid = true
      this.val.amount      = this.form.amount !== '' && Number(this.form.amount) > 0 ? null : false
      this.val.description = this.form.description.trim() !== '' ? null : false
      if (this.val.amount === false || this.val.description === false) valid = false
      return valid
    },

    async submitBalance() {
      if (!this.validateForm()) return
      this.loadButton = false

      const amount = Number(this.form.amount)
      const payload = {
        customerID:  this.customerId,
        balanceType: this.balanceType,
        balanceId:   this.form.balanceId,
        description: this.form.description.trim(),
        income:      this.form.type === 'income' ? amount : null,
        expense:     this.form.type === 'expense' ? amount : null,
      }

      try {
        let response = await axios.post(
          taobaoService_dotnet + 'app/Branch/add-edit-balance',
          payload,
          { headers: header_token }
        )
        if (response.data == 'success' || response.data.message == 'success') {
          this.$refs['balanceModal'].hide()
          await this.getBalancePage()
          this.$bvToast.toast('แก้ไขรายการสำเร็จ', {
            title: 'สำเร็จ', variant: 'success', solid: true, toaster: 'b-toaster-top-right'
          })
        }
      } catch (e) {
        console.error(e)
        this.$bvToast.toast('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง', {
          title: 'ผิดพลาด', variant: 'danger', solid: true, toaster: 'b-toaster-top-right'
        })
      } finally {
        this.loadButton = true
      }
    },

    // ============ Delete Balance ============
    async confirmDelete(type, item) {
      this.$swal({
        icon: 'warning',
        title: 'ยืนยันการลบ',
        text: `ต้องการลบรายการ "${item.description}" ใช่หรือไม่?`,
        showCancelButton: true,
        confirmButtonText: 'ลบ',
        cancelButtonText: 'ยกเลิก',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-outline-secondary ml-1',
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            let response = await axios.post(
              taobaoService_dotnet + 'app/Branch/delete-balance',
              {
                "balanceId": item.balanceId,
                "balanceType": type,
                "customerID": this.customerId,
              },
              { headers: header_token }
            )
            if (response.data == 'success' || response.data.message == 'success') {
              await this.getBalancePage()
              this.$bvToast.toast('ลบรายการสำเร็จ', {
                title: 'สำเร็จ', variant: 'success', solid: true, toaster: 'b-toaster-top-right'
              })
            }
          } catch (e) {
            console.error(e)
            this.$bvToast.toast('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง', {
              title: 'ผิดพลาด', variant: 'danger', solid: true, toaster: 'b-toaster-top-right'
            })
          }
        }
      })
    },

    // ============ Payment Modal (แจ้งชำระเงิน) ============
    async getListPayment() {
      let response = await axios.post(
        taobaoService_dotnet + 'app/Payment/load-payment-page',
        {
          "customerID": this.customerId,
          "isAdmin": true
        },
        { headers: header_token }
      )
      this.transfers = response.data.transfers
      this.balanceDeducts = response.data.balanceDeducts
      this.bankInfo = response.data.bankInfos
    },

    openPaymentModal() {
      this.resetPaymentForm()
      this.$refs['paymentModal'].show()
    },

    resetPaymentForm() {
      this.loadBtnPayment = true
      this.payment.choosePayment    = 'A'
      this.payment.chooseBank       = ''
      this.payment.amount           = null
      this.payment.date             = new Date()
      this.payment.time             = new Date().toLocaleString(undefined, {hour: '2-digit', hour12: false, minute:'2-digit'})
      this.payment.selectedPayment  = null
      this.payment.pic              = null
      this.payment.remark           = ''
      this.valPayment.bank              = null
      this.valPayment.amount            = null
      this.valPayment.selectedPayment   = null
    },

    validatePayment() {
      let valid = true
      if (this.payment.choosePayment == 'A') {
        if (this.payment.chooseBank == '') {
          this.valPayment.bank = false
          valid = false
        }
        if (this.payment.amount == null || this.payment.amount == '') {
          this.valPayment.amount = false
          valid = false
        }
      }
      if (this.payment.selectedPayment == null) {
        this.valPayment.selectedPayment = false
        valid = false
      }
      return valid
    },

    async submitPayment() {
      if (!this.validatePayment()) return
      this.loadBtnPayment = false

      try {
        if (this.payment.choosePayment == 'A') {
          // โอนเงินผ่านธนาคาร
          var datetime = ''
          var time12 = this.payment.time.split(":")
          if (typeof this.payment.date === 'string' && this.payment.date.length == 10) {
            datetime = formatDate_eng(this.payment.date) + ' ' + (time12[0] == '24' ? '00:' + time12[1] : this.payment.time)
          } else {
            datetime = formatDate_eng(this.payment.date.toISOString().slice(0, 10)) + ' ' + (time12[0] == '24' ? '00:' + time12[1] : this.payment.time)
          }

          var FormData = require('form-data')
          var data = new FormData()
          data.append('Amount', Number(this.payment.amount.replace(/,/g, "")))
          data.append('BankID', this.payment.chooseBank)
          data.append('CustomerID', this.customerId)
          data.append('Image', this.payment.pic)
          data.append('PaymentDescription', this.transfers.filter(x => x.paymentID == this.payment.selectedPayment)[0].description)
          data.append('PaymentID', this.payment.selectedPayment)
          data.append('Remark', this.payment.remark)
          data.append('TransferDate', datetime)
          data.append('IsAdmin', true)

          let response = await axios.post(
            taobaoService_dotnet + 'app/Payment/add-transfer-payment',
            data,
            { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('auth_token'), 'Content-Type': 'multipart/form-data' } }
          )
          if (response.data.status == 'success') {
            this.$refs['paymentModal'].hide()
            await this.getBalancePage()
            this.$bvToast.toast('แจ้งชำระเงินเรียบร้อย', {
              title: 'สำเร็จ', variant: 'success', solid: true, toaster: 'b-toaster-top-right'
            })
          } else if (response.data.status == 'error') {
            this.$swal({
              title: 'แจ้งชำระเงินไม่สำเร็จ',
              text: response.data.error_description,
              icon: 'warning',
              confirmButtonText: 'เข้าใจแล้ว',
              customClass: { confirmButton: 'btn btn-primary' },
              buttonsStyling: false,
            })
          }
        } else if (this.payment.choosePayment == 'B') {
          // หักยอดเงินบาทจาก Balance
          var des = this.balanceDeducts.filter(x => x.paymentID == this.payment.selectedPayment)[0].description
          let response = await axios.post(
            taobaoService_dotnet + 'app/Payment/add-balance-deduct-payment',
            {
              "customerID": this.customerId,
              "paymentDescription": des,
              "paymentID": this.payment.selectedPayment,
              "remark": this.payment.remark,
              "isAdmin": true
            },
            { headers: header_token }
          )
          if (response.data.status == 'success') {
            this.$refs['paymentModal'].hide()
            await this.getBalancePage()
            this.$bvToast.toast('แจ้งชำระเงินเรียบร้อย', {
              title: 'สำเร็จ', variant: 'success', solid: true, toaster: 'b-toaster-top-right'
            })
          } else if (response.data.status == 'error') {
            this.$swal({
              title: 'แจ้งชำระเงินไม่สำเร็จ',
              text: response.data.error_description,
              icon: 'warning',
              confirmButtonText: 'เข้าใจแล้ว',
              customClass: { confirmButton: 'btn btn-primary' },
              buttonsStyling: false,
            })
          }
        }
      } catch (e) {
        console.error(e)
        this.$bvToast.toast('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง', {
          title: 'ผิดพลาด', variant: 'danger', solid: true, toaster: 'b-toaster-top-right'
        })
      } finally {
        this.loadBtnPayment = true
      }
    },

    // ============ Exchange Yuan to Baht ============
    async getRateYuan() {
      let response = await axios.post(
        taobaoService_dotnet + 'app/Balance/load-change-yuan-to-bath',
        {
          "customerID": this.customerId,
          "isAdmin": true
        },
        { headers: header_token }
      )
      this.rateYuan = response.data.rate
      this.totalYuan = response.data.customerYuanBalance
    },

    openExchangeModal() {
      this.resetExchangeForm()
      this.$refs['exchangeModal'].show()
    },

    resetExchangeForm() {
      this.loadBtnExchange    = true
      this.exchangeAmountYuan = ''
      this.exchangeTotalBaht  = null
      this.exchangeCheckNull  = true
    },

    async exchangeYuanToBaht() {
      this.loadBtnExchange = false
      try {
        let response = await axios.post(
          taobaoService_dotnet + 'app/Balance/exchange-yuan-to-bath',
          {
            "customerID": this.customerId,
            "amountYuan": Number(this.exchangeAmountYuan.replace(/,/g, "")),
            "isAdmin": true,
          },
          { headers: header_token }
        )
        if (response.data.status == 'success') {
          this.$refs['exchangeModal'].hide()
          await this.getBalancePage()
          await this.getRateYuan()
          this.$bvToast.toast('แลกเงินหยวนเป็นบาทเรียบร้อย', {
            title: 'สำเร็จ', variant: 'success', solid: true, toaster: 'b-toaster-top-right'
          })
        }
      } catch (e) {
        console.error(e)
        this.$bvToast.toast('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง', {
          title: 'ผิดพลาด', variant: 'danger', solid: true, toaster: 'b-toaster-top-right'
        })
      } finally {
        this.loadBtnExchange = true
      }
    },
  },
};
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style scoped>

</style>
